var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8403 0C6.19652 0 0 6.26802 0 14C0 21.732 6.19652 28 13.8403 28C21.4841 28 27.6806 21.732 27.6806 14C27.6806 6.26802 21.4841 0 13.8403 0ZM23.0127 23.2782C20.5626 25.7565 17.3052 27.1213 13.8403 27.1213C10.3754 27.1213 7.11797 25.7565 4.66795 23.2782C2.21792 20.7999 0.868638 17.5049 0.868638 14C0.868638 10.4951 2.21792 7.2001 4.66795 4.72181C7.11797 2.24351 10.3754 0.878661 13.8403 0.878661C17.3052 0.878661 20.5626 2.24351 23.0127 4.72181C25.4627 7.2001 26.812 10.4951 26.812 14C26.812 17.5049 25.4627 20.7999 23.0127 23.2782Z",
    fill: "#D8E1F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9967 21V20.9995H21.0002V15.865C21.0002 13.3531 20.4595 11.4182 17.523 11.4182C16.1113 11.4182 15.164 12.1929 14.7772 12.9273H14.7364V11.6527H11.9521V20.9995H14.8513V16.3713C14.8513 15.1527 15.0823 13.9744 16.5914 13.9744C18.0783 13.9744 18.1005 15.365 18.1005 16.4495V21H20.9967Z",
    fill: "#D8E1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23096 11.6531H10.1336V20.9998H7.23096V11.6531Z",
    fill: "#D8E1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68117 7C7.75308 7 7 7.75308 7 8.68117C7 9.60925 7.75308 10.3781 8.68117 10.3781C9.60925 10.3781 10.3623 9.60925 10.3623 8.68117C10.3617 7.75308 9.60867 7 8.68117 7V7Z",
    fill: "#D8E1F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d3a25b9d3926c8add6cc2a194d2be58b.svg";
export { ForwardRef as ReactComponent };